var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfxNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 61.77,
    y1: 7922.93,
    x2: 61.77,
    y2: 7989.54,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 8030.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 50.28,
    y1: 7958.69,
    x2: 50.28,
    y2: 7976.5,
    xlinkHref: "#linear-gradient"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 50.28,
    y1: 7963.98,
    x2: 50.28,
    y2: 7975.08,
    xlinkHref: "#linear-gradient"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.33,
    y: 55.38,
    width: 15.9,
    height: 10.72,
    style: {
      fill: "none"
    }
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 50.28,
    y1: 7935.84,
    x2: 50.28,
    y2: 7953.65,
    xlinkHref: "#linear-gradient"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 50.28,
    y1: 7941.13,
    x2: 50.28,
    y2: 7952.23,
    xlinkHref: "#linear-gradient"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.33,
    y: 78.23,
    width: 15.9,
    height: 10.72,
    style: {
      fill: "none"
    }
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -405.99,
    y1: 6625.12,
    x2: -405.99,
    y2: 6691.73,
    gradientTransform: "matrix(0, 1, 1, 0, -6583.36, 480.99)",
    xlinkHref: "#linear-gradient"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -406.05,
    y1: 6646.93,
    x2: -406.05,
    y2: 6664.49,
    gradientTransform: "matrix(0, 1, 1, 0, -6581.24, 483.69)",
    xlinkHref: "#linear-gradient"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 268.76,
    y1: 7865.24,
    x2: 268.76,
    y2: 7910,
    gradientTransform: "matrix(1, 0, 0, -1, -179, 7969.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b3b3b3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3",
    stopOpacity: 0.05
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 254.93,
    y1: 7894.03,
    x2: 254.93,
    y2: 7896.19,
    gradientTransform: "matrix(1, 0, 0, -1, -179, 7969.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  }))), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 264.83,
    y1: 7896.51,
    x2: 264.83,
    y2: 7903.09,
    xlinkHref: "#linear-gradient-9"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 26") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.98,
    y: 40.79,
    width: 49.57,
    height: 66.61,
    style: {
      fill: "url(#linear-gradient)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.63,
    y: 41.7,
    width: 48.02,
    height: 64.29,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.37,
    y: 44.41,
    width: 16.52,
    height: 0.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.37,
    y: 46.73,
    width: 16.52,
    height: 0.52,
    style: {
      fill: "#3fa9f5",
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.35,
    y: 44.41,
    width: 16.52,
    height: 0.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.93,
    y: 59.12,
    width: 16.52,
    height: 0.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.32,
    y: 60.54,
    width: 16.52,
    height: 0.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.09,
    y: 61.96,
    width: 16.52,
    height: 0.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.93,
    y: 81.97,
    width: 16.52,
    height: 0.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.32,
    y: 83.39,
    width: 16.52,
    height: 0.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.09,
    y: 84.81,
    width: 16.52,
    height: 0.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 53.83,
    width: 17.56,
    height: 17.82,
    style: {
      fill: "url(#linear-gradient-2)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.61,
    y: 54.22,
    width: 17.28,
    height: 17.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.22,
    y: 55.25,
    width: 16.12,
    height: 11.1,
    style: {
      fill: "url(#linear-gradient-3)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "e1f34465-d008-41db-868b-e00503fb87b3",
    x: 42.33,
    y: 55.38,
    width: 15.9,
    height: 10.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "40.98 65.71 44.98 59.51 46.66 62.22 50.28 58.48 53.38 62.22 56.09 56.67 63.06 67.77 40.47 67 40.98 65.71",
    style: {
      fill: "#3fa9f5",
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.08,
    cy: 56.93,
    r: 1.16,
    style: {
      fill: "#3fa9f5",
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 76.68,
    width: 17.56,
    height: 17.82,
    style: {
      fill: "url(#linear-gradient-4)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.61,
    y: 77.07,
    width: 17.28,
    height: 17.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.22,
    y: 78.1,
    width: 16.12,
    height: 11.1,
    style: {
      fill: "url(#linear-gradient-5)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "c95ac4f6-be4d-44a3-92c2-5c8066e2b531",
    x: 42.33,
    y: 78.23,
    width: 15.9,
    height: 10.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "40.98 88.56 44.98 82.36 46.66 85.07 50.28 81.33 53.38 85.07 56.09 79.52 63.06 90.62 40.47 89.85 40.98 88.56",
    style: {
      fill: "#bdbdbd",
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.08,
    cy: 79.78,
    r: 1.16,
    style: {
      fill: "#bdbdbd",
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.75,
    y: 50.21,
    width: 66.61,
    height: 49.57,
    transform: "translate(-13.13 134) rotate(-78.76)",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42.84,
    y: 50.71,
    width: 64.29,
    height: 48.02,
    transform: "translate(-12.92 133.7) rotate(-78.76)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.95,
    y: 28.64,
    width: 0.52,
    height: 34.08,
    transform: "translate(17.36 112.5) rotate(-78.76)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.44,
    y: 76.5,
    width: 0.52,
    height: 34.08,
    transform: "translate(-37.25 141.71) rotate(-78.76)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.06,
    y: 82.53,
    width: 0.52,
    height: 26.34,
    transform: "translate(-42.89 139.15) rotate(-78.76)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 92.1,
    width: 0.52,
    height: 9.81,
    transform: "translate(-51.15 131.68) rotate(-78.76)",
    style: {
      fill: "#3fa9f5",
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.01,
    y: 38.41,
    width: 0.52,
    height: 17.04,
    transform: "translate(8.93 104.75) rotate(-78.76)",
    style: {
      fill: "#3fa9f5",
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.15,
    y: 35.81,
    width: 0.52,
    height: 30.73,
    transform: "translate(9.71 114.18) rotate(-78.76)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.17,
    y: 48.08,
    width: 0.52,
    height: 7.49,
    transform: "translate(-0.57 102.96) rotate(-78.76)",
    style: {
      fill: "#3ad29f",
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.64,
    y: 40.29,
    width: 0.52,
    height: 34.08,
    transform: "translate(4.07 119.61) rotate(-78.76)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.69,
    y: 62.35,
    width: 17.56,
    height: 30.6,
    transform: "translate(-16.2 135.55) rotate(-78.76)",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 65.9,
    y: 62.48,
    width: 17.17,
    height: 30.21,
    transform: "translate(-16.13 135.52) rotate(-78.76)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.06,
    y: 43.2,
    width: 0.52,
    height: 34.08,
    transform: "translate(0.74 121.39) rotate(-78.76)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.35,
    y: 73.75,
    width: 12.52,
    height: 3.74,
    transform: "translate(-22.15 124.25) rotate(-78.76)",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.6,
    y: 77.08,
    width: 8.39,
    height: 3.74,
    transform: "translate(-20.45 133) rotate(-78.76)",
    style: {
      fill: "#3ad29f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.74,
    y: 80.29,
    width: 4.52,
    height: 3.74,
    transform: "matrix(0.19, -0.98, 0.98, 0.19, -18.6, 141.67)",
    style: {
      fill: "#f55f44"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.46,
    y: 79.32,
    width: 9.17,
    height: 3.74,
    transform: "translate(-11.98 147.79) rotate(-78.76)",
    style: {
      fill: "#fdd835"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.48,65.09a17.23,17.23,0,0,0-24.37-.48l-.3.29A17.23,17.23,0,0,0,94.66,91.34l12.46,13a.84.84,0,0,0,1.19,0l3.1-3a.84.84,0,0,0,0-1.19L99,87.19A17.23,17.23,0,0,0,97.48,65.09ZM93.6,85.92a12.33,12.33,0,1,1,.34-17.43,12.33,12.33,0,0,1-.34,17.43Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.93,73.61a1.08,1.08,0,0,0,0,2.15A1.08,1.08,0,0,0,75.93,73.61Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.59,66.71a10.35,10.35,0,0,0-8.93,4.61c-.59.92,1.08,1.74,1.67.82a8.54,8.54,0,0,1,7.41-3.75,9.44,9.44,0,0,1,7.7,4.48c.59,1,2.13.09,1.55-.88A11.48,11.48,0,0,0,85.59,66.71Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.83,64.43A17.23,17.23,0,0,0,74.47,64l-.3.29A17.23,17.23,0,0,0,96,90.68l12.46,13a.84.84,0,0,0,1.19,0l3.1-3a.84.84,0,0,0,0-1.19l-12.46-13A17.23,17.23,0,0,0,98.83,64.43ZM95,85.26a12.33,12.33,0,1,1,.34-17.43A12.33,12.33,0,0,1,95,85.26Z",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.28,73a1.08,1.08,0,0,0,0,2.15A1.08,1.08,0,0,0,77.28,73Z",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.95,66.05A10.35,10.35,0,0,0,78,70.66c-.59.92,1.08,1.74,1.67.82a8.54,8.54,0,0,1,7.41-3.75,9.44,9.44,0,0,1,7.7,4.48c.59,1,2.13.09,1.55-.88A11.44,11.44,0,0,0,86.95,66.05Z",
    style: {
      fill: "#3fa9f5"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxNoResults);
export default __webpack_public_path__ + "static/media/gfx-no-results.92561880284744297a9ca9e7d3037035.svg";
export { ForwardRef as ReactComponent };